export default {
  checkCarPlateNumber:
    "/gateway/partyH5App/carMinister/carInsuranceInquirycs/checkCarPlateNumber", // 查询车辆是否在服务范围内
};



// WEBPACK FOOTER //
// ./src/vehicleInquiry/index/api.js